import React from "react";
import {
  Text,
  VStack,
  Container,
  Heading,
  Box,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";

function TermsOfUseLocation() {
  const { pathname } = useLocation();
  const appName = decodeURIComponent(pathname.substring(14));

  const Section = ({ title, children }) => (
    <Box mb={8}>
      <Text fontSize="m" color="#fff" fontWeight="bold" mb={2}>
        {title}
      </Text>
      <Text fontSize="m" color="#fff">
        {children}
      </Text>
    </Box>
  );

  const SubSection = ({ title, children }) => (
    <Box ml={4} mb={4}>
      <Text fontSize="m" color="#fff" fontWeight="semibold" mb={2}>
        {title}
      </Text>
      <Text fontSize="m" color="#fff">
        {children}
      </Text>
    </Box>
  );

  return (
    <div className="container">
      <div className="header">
        <div className="header__right">
          <ChakraLink href="/">
            <Text fontWeight="black" color="#fff" fontSize={20}>
              Muhammed Deniz
            </Text>
          </ChakraLink>
        </div>

        <div className="header__left">
          <Link to="/home">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Home
            </Text>
          </Link>
          <Link to="/privacypolicy/ChatGame">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Privacy Policy
            </Text>
          </Link>
          <Link to="/termsOfUse/ChatGame">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Terms Of Use
            </Text>
          </Link>
        </div>
      </div>

      <Container maxW="container.lg" py={16}>
        <VStack align="stretch" spacing={6}>
          <Heading as="h1" size="xl" color="#fff" mb={8}>
            Terms of Use
          </Heading>

          <Text fontSize="m" color="#fff">
            Welcome to <strong>{appName}</strong>! These terms and conditions
            outline the rules and regulations for the use of our field tracking
            and agricultural management application, available through the{" "}
            <strong>{appName}</strong> website and application.
          </Text>

          <Text fontSize="m" color="#fff">
            By accessing and using <strong>{appName}</strong>, you agree to be
            bound by these terms and conditions. If you do not agree to these
            terms, please do not use the application.
          </Text>

          <Section title="1. User License">
            Permission is granted to download, install, and use{" "}
            <strong>{appName}</strong> for personal and non-commercial purposes
            on compatible devices, solely for the purpose of tracking field
            coverage, monitoring agricultural activities, and managing farm
            operations.
          </Section>

          <Section title="2. User Obligations">
            You agree not to use <strong>{appName}</strong> for any illegal or
            unauthorized purpose, and you must not violate any laws in your
            jurisdiction. You also agree not to modify, adapt, or hack{" "}
            <strong>{appName}</strong> or modify another website to falsely
            imply that it is associated with <strong>{appName}</strong>.
          </Section>

          <Section title="3. Content">
            The content you create, submit, or display while using{" "}
            <strong>{appName}</strong> is your responsibility. You agree not to
            upload or share content that is obscene, defamatory, harmful, or
            violates any third-party rights.
          </Section>

          <Section title="4. Subscription Services">
            <SubSection title="4.1 Subscription Terms">
              • <strong>{appName}</strong> offers auto-renewable subscription
              options:
              <br />
              • Weekly Subscription
              <br />
              • Annual Subscription
              <br />
              • Subscription automatically renews unless auto-renew is turned
              off at least 24-hours before the end of the current period
              <br />
              • Account will be charged for renewal within 24-hours prior to the
              end of the current period
              <br />• Subscriptions may be managed by the user and auto-renewal
              may be turned off by going to the user's Account Settings after
              purchase
            </SubSection>

            <SubSection title="4.2 Payment and Billing">
              • Payment will be charged to your Apple ID account at confirmation
              of purchase
              <br />
              • All purchases are processed through the Apple App Store using
              your Apple ID
              <br />
              • Prices are subject to change without notice
              <br />• Subscription prices are clearly displayed in the app
              before purchase
            </SubSection>

            <SubSection title="4.3 Cancellation and Refunds">
              • You can cancel your subscription at any time through your Apple
              ID account settings
              <br />
              • Cancellation will take effect at the end of the current
              subscription period
              <br />
              • No refunds will be issued for partial subscription periods,
              except where required by law
              <br />• Free trial periods, if offered, will automatically convert
              to paid subscriptions unless cancelled before the trial period
              ends
            </SubSection>
          </Section>

          <Section title="5. Intellectual Property">
            <strong>{appName}</strong> and its original content, features, and
            functionality are owned by us and are protected by international
            copyright, trademark, patent, trade secret, and other intellectual
            property or proprietary rights laws.
          </Section>

          <Section title="6. App Store Requirements">
            • All purchases and subscriptions are processed through Apple's App
            Store
            <br />
            • Use of the app is also subject to Apple's Terms of Service
            <br />• Any issues related to billing or purchases should be
            directed to Apple Support
          </Section>

          <Section title="7. Limitations">
            We shall not be liable for any damages arising from your use of{" "}
            <strong>{appName}</strong>, including but not limited to direct,
            indirect, incidental, punitive, and consequential damages.
          </Section>

          <Section title="8. Changes">
            We reserve the right to modify or replace these terms at any time.
            By continuing to access or use <strong>{appName}</strong> after such
            changes, you agree to be bound by the updated terms.
          </Section>

          <Section title="9. Governing Law">
            These terms are governed by and construed in accordance with the
            laws of your jurisdiction, without regard to its conflict of law
            provisions.
          </Section>

          <Section title="10. Location Data Usage">
            • <strong>{appName}</strong> requires access to your device's
            location to function properly
            <br />
            • You acknowledge and agree that the app will collect your location
            data while actively using the app to track field scanning activities
            <br />
            • Location data is stored locally on your device only and is not
            transmitted to our servers
            <br />
            • Location data is used solely to calculate field coverage, field
            boundaries, and efficiency metrics
            <br />
            • You can revoke location permissions at any time through your
            device settings, but this will limit core app functionality
            <br />• For complete details on how we handle location data, please
            refer to our Privacy Policy
          </Section>

          <Box mt={10}>
            <Text fontSize="m" color="#fff">
              If you have any questions about these terms, please contact us at
              mdeniz.info@gmail.com.
            </Text>
          </Box>

          <Box mt={10}>
            <Text fontSize="s" color="#fff" textAlign="right">
              Last updated: January 28, 2025
            </Text>
            <Text
              fontSize="s"
              color="#fff"
              fontWeight="hairline"
              textAlign="right"
            >
              <strong>{appName}</strong> Inc.
            </Text>
          </Box>
        </VStack>
      </Container>
    </div>
  );
}

export default TermsOfUseLocation;
